import $ from 'jquery';
import { Navigation, Pagination, Swiper } from 'swiper';
import { $Elements, Durations, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, loadExternalScript } from './helpers';

// ---------- Regiondo ----------


$Elements.document.on(Events.page.enter, () => {

	const hasRegiondoCTA = document.getElementById('ctaWidgetRegiondo') || document.querySelector('.btn-modal[data-id]');

	if(hasRegiondoCTA && !document.getElementById('regiondo-js')) {
		loadExternalScript('<script id="regiondo-js" src="https://cdn.regiondo.net/js/integration/bookingwidget/bookingwidget.js"></script>');
	}

	// ---------- Modal ----------
	$('.btn-modal').off('click.regiondo').on('click.regiondo', function() {

		const id = String($(this).data('id'));
		let $modal = $('#widgetModal');

		if(!$modal.length || String($modal.data('widget-id')) !== id) {
			const modalHtml = `
                <div class="modal fade" id="widgetModal" tabindex="-1" aria-hidden="true" data-widget-id="${id}">
                    <div class="modal-dialog">
                        <div class="modal-content" data-lenis-prevent>
                            <div class="modal-header">
                                <button id="closeWidget" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                               <booking-widget widget-id=${id}></booking-widget>
                            </div>
                        </div>
                    </div>
                </div>
            `;

			$modal.remove();
			$('body').append(modalHtml);
			$modal = $('#widgetModal');
		}

		$modal.off('show.bs.modal.regiondo').on('show.bs.modal.regiondo', () => {
			disableBodyScroll();
		});

		$modal.off('hidden.bs.modal.regiondo').on('hidden.bs.modal.regiondo', () => {
			enableBodyScroll();
		});

		$modal.modal('show');

		$('#closeWidget').off('click.regiondo').on('click.regiondo', function() {
			$modal.modal('hide');
		})
	});

	// ---------- Dropdown de langue ----------
	$('.cta-widget .dropdown')
		.off('shown.bs.dropdown.regiondo hidden.bs.dropdown.regiondo')
		.on('shown.bs.dropdown.regiondo', function() {

			const $toggle = $(this).find('.dropdown-toggle');
			const origin = window.scrollY;

			$Elements.window.on('scroll.regiondoDropdown', () => {

				if(Math.abs(window.scrollY - origin) > 10) {
					$toggle.dropdown('hide');
				}
			});
		})
		.on('hidden.bs.dropdown.regiondo', () => {
			$Elements.window.off('scroll.regiondoDropdown');
		});

	// ---------- Reviews Carousel ----------
	$('.reviews-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				modules: [Navigation, Pagination],
				loop: false,
				observer: true,
				speed: Durations.animations.ms,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					480: {
						slidesPerView: 1
					},
					768: {
						slidesPerView: 2
					},
					1280: {
						slidesPerView: 2
					}
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
					clickable: true
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

});
